// extracted by mini-css-extract-plugin
module.exports = {"blur":"SkeletonSearchDesktop-module__blur___DxdDs"};